import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, combineLatest, filter, map } from 'rxjs';
import { PAGES_WITHOUT_HEADER } from 'src/app/core/constants/pages-without-header';

import { User } from '../../../../../models/user';
import { UserService } from '../../../../services/user.service';
import { LandingHeaderComponent } from '../landing-header/landing-header.component';
import { UserHeaderComponent } from '../user-header/user-header.component';

interface HeaderWrapperData {
  user: User;
  showHeader: boolean;
  isUserCompanySc: boolean;
}

@Component({
  selector: 'app-header-wrapper',
  templateUrl: './header-wrapper.component.html',
  styleUrls: ['./header-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LandingHeaderComponent, UserHeaderComponent, AsyncPipe],
})
export class HeaderWrapperComponent implements OnInit {
  router = inject(Router);
  private userService = inject(UserService);
  private destroyRef = inject(DestroyRef);

  headerWrapperData$: Observable<HeaderWrapperData>;

  ngOnInit(): void {
    this.headerWrapperData$ = this.getHeaderWrapperData();
  }

  private getShowHeaderObservable(): Observable<boolean> {
    return this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => !PAGES_WITHOUT_HEADER.some((page) => this.router.url.startsWith(page))),
    );
  }

  private getHeaderWrapperData(): Observable<HeaderWrapperData> {
    return combineLatest([this.userService.getUserObservable(), this.getShowHeaderObservable()]).pipe(
      map(([user, showHeader]) => ({
        user,
        showHeader,
        isUserCompanySc: this.userService.checkUserIsScCompany(user),
      })),
      takeUntilDestroyed(this.destroyRef),
    );
  }
}
